import React, { FunctionComponent } from 'react';
import { Container } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Location } from 'history';
import queryString from 'query-string';

import { ClassProp } from 'helpers/types';

import {
  Values,
  SearchTypeValues,
} from 'scenes/Home/components/MerchantVenueSearch/MerchantVenueSearch.helper';

import SearchHeader from './sections/SearchHeader';
import SearchResults from './sections/SearchResults';

const styles = {
  container: {
    margin: '10.5rem auto 0 !important',
    height: 'auto !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  location: Location;
};

const VenusSearch: FunctionComponent<Props> = ({ classes, location }) => {
  const {
    searchType = SearchTypeValues.Vmid,
    searchText = '',
    cnidsToFilter = '',
    filter = '',
  }: Values = queryString.parse(location.search);

  return (
    <Container className={classes.container}>
      <SearchHeader searchType={searchType} searchText={searchText} />
      <SearchResults
        searchType={searchType}
        searchText={searchText}
        cnidsToFilter={cnidsToFilter}
        filter={filter}
      />
    </Container>
  );
};

export default compose<Props, any>(withRouter, withStyles(styles))(VenusSearch);
